import { TipoSoggettoAnagrafeEnum } from "../enum/tipo-soggetto-anagrafe-enum";

export class SoggettoRicercaVO {
    tipo: TipoSoggettoAnagrafeEnum;
    denominazione: string;
    nome: string;
    cognome: string;
    codiceFiscale: string;
    ipa: boolean;
    output: string;
  }
  